import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import PhotoForm, { photoFormPropTypes } from '../photos/photo_form';

export class AssignmentEditForm extends React.Component {
  static propTypes = {
    domNodes: PropTypes.shape({
      photoFormElement: PropTypes.object.isRequired
    }),
    photoProps: PropTypes.shape({
      ...photoFormPropTypes
    })
  }

  render() {
    return ReactDOM.createPortal(
      <PhotoForm {...this.props.photoProps} maxPhotos={100} />,
      this.props.domNodes.photoFormElement
    );
  }
}

export default class AssignmentEditFormWrapper extends React.Component {
  static propTypes = {
    domIds: PropTypes.shape({
      photoForm: PropTypes.string.isRequired
    })
  }

  domNodes = {
    photoFormElement: document.getElementById(this.props.domIds.photoForm)
  }

  render() {
    const { domIds, ...props } = this.props;
    return (
      <AssignmentEditForm
        {...props}
        domNodes={this.domNodes}
      />
    );
  }
}
